// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"DesktopNav_backdrop__29_RZ","desktopNav":"DesktopNav_desktopNav__d-39F","menu":"DesktopNav_menu__33pzP","search":"DesktopNav_search__193vF"};